export default __webpack_public_path__ + "static/media/vip-up-level-ico.b97a645d.svg";